import { render, staticRenderFns } from "./KlipperLoadChart.vue?vue&type=template&id=5bdaef49&"
import script from "./KlipperLoadChart.vue?vue&type=script&lang=ts&"
export * from "./KlipperLoadChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
